module.exports = __webpack_public_path__ + "img/uk-respiratory-diseases-male.52546d80.png";